<template>
  <div class="countdown" v-if="timeText != '无'">
    <div class="text">下次提醒 {{ timeText }}</div>
    <div class="time">{{ changeTime | filterTime }}</div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    status: {
      type: Number,
      default: 0
    },
    curTime: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      constantTime: 0, //固定不变的倒计时间
      changeTime: 0 //变动的倒计时间
    }
  },
  filters: {
    filterTime(time) {
      let hours = Math.floor(time / 60 / 60)
      let minite = Math.floor((time - hours * 60 * 60) / 60)
      let second = time - hours * 60 * 60 - minite * 60
      let hoursStr = hours < 10 ? '0' + hours : hours
      let miniteStr = minite < 10 ? '0' + minite : minite
      let secondStr = second < 10 ? '0' + second : second
      return hoursStr + ':' + miniteStr + ':' + secondStr
    }
  },
  computed: {
    timeText() {
      let item = this.data[this.data.length - this.status + 1]
      return (item && item.time_slot) || '无'
    },
    //倒计时时间
    countDownTime() {}
  },
  watch: {
    data() {
      this.initTime(this.status, this.data, this.curTime)
    },
    status() {
      this.initTime(this.status, this.data, this.curTime)
    }
  },
  mounted() {
    this.initTime(this.status, this.data, this.curTime)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    //根据数据计算出当前倒计时
    initTime(status, list, curTime) {
      if (!list.length) {
        return
      }
      let now = new Date(parseInt(curTime) * 1000)
      let hours = now.getHours()
      let minute = now.getMinutes()
      let second = now.getSeconds()
      //当日凌晨时间
      let curDayTime =
        now.getTime() -
        hours * (1000 * 60 * 60) -
        minute * (1000 * 60) -
        second * 1000
      if (status <= 0) {
        //任务已完成
        this.constantTime = 0
      } else {
        /* 未完成 */
        let time =
          (this.convertStrToTime(
            list[list.length - status + 1] &&
              list[list.length - status + 1].time_slot,
            curDayTime
          ) -
            now.getTime()) /
          1000
        this.constantTime = time
      }
      this.startInterval(this.constantTime)
    },
    //将当日时间hh:mm转换成时间戳
    convertStrToTime(str, curDayTime) {
      if (!str) {
        return 0
      }
      let arr = str.split(':')
      let hours = parseInt(arr[0])
      let minute = parseInt(arr[1])
      let res = curDayTime + hours * 1000 * 60 * 60 + minute * (1000 * 60)
      return res
    },
    //开始倒计时
    startInterval(time) {
      if (time <= 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.changeTime = time
      this.timer = setInterval(() => {
        this.changeTime--
        if (this.changeTime <= 0) {
          this.changeTime = 0
          clearInterval(this.timer)
          this.$emit('change')
        }
      }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.text {
  font-size: 14px;
  white-space: nowrap;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  line-height: 20px;
  margin-bottom: 5px;
}
.time {
  font-size: 24px;
  font-family: DINCondensed-Bold, DINCondensed;
  color: #6236ff;
  display: flex;
  align-items: center;
  height: 20px;
  justify-content: center;
}
</style>
